const BANKING = '/banking'
const LOGIN = BANKING
const PASSWORD_RECOVERY = BANKING + '/recuperacaoSenha'
const NEW_PASSWORD = BANKING + '/novaSenha'
const LOGIN_EMULADO = BANKING + '/loginEmulado'
const TROCA_APLICACAO = BANKING + '/loginTrocaAplicacao'
const HOME = BANKING + '/dashboard'
const BANK_STATEMENT = BANKING + '/extratoBancario'
const BANK_BALANCE = BANKING + '/saldoBancario'
const DIGITAL_WALLET_BALANCE = BANKING + '/saldoCarteiraDigital'
const DUPLICATE_MOVEMENTS_ANALYSIS = BANKING + '/analiseDuplicidade'
const FINANCIAL_MOVEMENT = BANKING + '/movimentosFinanceiros'
const CONCILIATION_REPORT = BANKING + '/relatorioConciliacao'
const CONCILIATION_SUMMARY = BANKING + '/resumoConciliacao'
const CONCILIATION_SUMMARY_CALENDAR = BANKING + '/resumoConciliacao/calendario'
const MANUAL_CONCILIATION = BANKING + '/conciliacaoManual'
const OCCURRENCE_REPORT = BANKING + '/relatorioOcorrencias'
const PROCESSED_FILES = BANKING + '/arquivosProcessados'
const FILE_UPLOAD = BANKING + '/envioArquivos'
const REMITTANCE_INTEGRATION = BANKING + '/remessaIntegracao'
const LIST_BANK_ACCOUNTS = BANKING + '/contasBancarias'
const NEW_BANK_ACCOUNT = BANKING + '/contasBancarias/nova'
const LIST_ESTABLISHMENTS = BANKING + '/estabelecimentos'
const NEW_ESTABLISHMENT = BANKING + '/estabelecimentos/novo'
const MOVE_ESTABLISHMENT = BANKING + '/estabelecimentos/moverEstabelecimento'
const CATEGORIES = BANKING + '/categorias'
const LIST_CONCILIATION_PLANS = BANKING + '/planosConciliacao'
const NEW_CONCILIATION_PLAN = BANKING + '/planosConciliacao/novo'
const LIST_OCCURRENCE_REASONS = BANKING + '/motivosOcorrencia'
const NEW_OCCURRENCE_REASON = BANKING + '/motivosOcorrencia/novo'
const LIST_ATTRIBUTES_SET = BANKING + '/conjuntoAtributos'
const NEW_ATTRIBUTES_SET = BANKING + '/conjuntoAtributos/novo'
const LIST_ACCESS_PROFILE = BANKING + '/perfisAcesso'
const NEW_ACCESS_PROFILE = BANKING + '/perfisAcesso/novo'
const LIST_OPERATORS = BANKING + '/operadores'
const NEW_OPERATOR = BANKING + '/operadores/novo'
const LIST_ASSIGNMENT = BANKING + '/tarefas'
const AUDIT_LOG = BANKING + '/logsAuditoria'
const UNAUTHORIZED = BANKING + '/naoAutorizado'

const OFDA_REG_DEEPLINK = BANKING + '/ofdaRegDeeplink'

export default {
  BANKING,
  LOGIN,
  PASSWORD_RECOVERY,
  NEW_PASSWORD,
  LOGIN_EMULADO,
  TROCA_APLICACAO,
  HOME,
  BANK_STATEMENT,
  BANK_BALANCE,
  DIGITAL_WALLET_BALANCE,
  DUPLICATE_MOVEMENTS_ANALYSIS,
  FINANCIAL_MOVEMENT,
  CONCILIATION_REPORT,
  CONCILIATION_SUMMARY,
  CONCILIATION_SUMMARY_CALENDAR,
  MANUAL_CONCILIATION,
  OCCURRENCE_REPORT,
  PROCESSED_FILES,
  FILE_UPLOAD,
  REMITTANCE_INTEGRATION,
  LIST_BANK_ACCOUNTS,
  NEW_BANK_ACCOUNT,
  LIST_ESTABLISHMENTS,
  NEW_ESTABLISHMENT,
  MOVE_ESTABLISHMENT,
  CATEGORIES,
  LIST_CONCILIATION_PLANS,
  NEW_CONCILIATION_PLAN,
  LIST_OCCURRENCE_REASONS,
  NEW_OCCURRENCE_REASON,
  LIST_ATTRIBUTES_SET,
  NEW_ATTRIBUTES_SET,
  LIST_ACCESS_PROFILE,
  NEW_ACCESS_PROFILE,
  LIST_OPERATORS,
  NEW_OPERATOR,
  LIST_ASSIGNMENT,
  AUDIT_LOG,
  UNAUTHORIZED,
  OFDA_REG_DEEPLINK
}



// WEBPACK FOOTER //
// ./client/router/routesMap.js